import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { X, Copy, Trash2, Replace } from 'lucide-react';

interface PortfolioBulkActionsToolbarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  onConvertToModel?: () => void;
  canConvertToModel?: boolean;
}

export function PortfolioBulkActionsToolbar({
  selectedCount,
  onClearSelection,
  onDuplicate,
  onDelete,
  onConvertToModel,
  canConvertToModel = false,
}: PortfolioBulkActionsToolbarProps) {
  if (selectedCount === 0) return null;
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-md px-3 py-2 mb-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Badge variant="secondary" className="bg-primary/15 text-primary text-xs">
            {selectedCount} portfolio{selectedCount !== 1 ? 's' : ''} selected
          </Badge>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            className="h-7 px-2 text-xs text-muted-foreground hover:text-foreground"
          >
            <X className="h-3 w-3 mr-1" />
            Clear
          </Button>
        </div>
        <div className="flex items-center gap-2">
          {selectedCount === 1 && onConvertToModel && (
            <Button
              variant="outline"
              size="sm"
              onClick={onConvertToModel}
              className="h-7 px-2 text-xs gap-1"
              disabled={!canConvertToModel}
            >
              <Replace className="h-3 w-3" />
              Convert to Model
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={onDuplicate}
            className="h-7 px-2 text-xs gap-1"
          >
            <Copy className="h-3 w-3" />
            Duplicate
          </Button>
          <Button
            variant="destructive"
            size="sm"
            onClick={onDelete}
            className="h-7 px-2 text-xs gap-1"
          >
            <Trash2 className="h-3 w-3" />
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
}
